module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selector', {
    attrs: {
      "draggable-group": "choices",
      "item-name-plural": "choice templates",
      "item-name": "choice template",
      "category-list": _vm.choiceCategoryList,
      "disabled-ids": _vm.selectorDisabledTemplateIds,
      "is-fixed": _vm.isFixed,
      "is-editable": _vm.isEditable,
      "search-text": _vm.selectorTemplateSearchText,
      "selected-category-id": _vm.selectorSelectedTemplateCategory,
      "selected-id": _vm.selectorSelectedTemplateId
    },
    on: {
      "onItemAdd": _vm.handleAddTemplate,
      "onItemEdit": _vm.handleEditTemplate,
      "onChangeCategory": _vm.handleSelectCategory,
      "onLoadMore": _vm.handleLoadMore,
      "onSelect": _vm.handleSelectTemplate,
      "onResetFilters": _vm.handleResetFilters,
      "onChangeSearchText": _vm.handleSearchText
    },
    model: {
      value: (_vm.choiceTemplates),
      callback: function($$v) {
        _vm.choiceTemplates = $$v
      },
      expression: "choiceTemplates"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ff9b276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/selectors/ChoiceTemplateSelector.vue
// module id = 3242
// module chunks = 3